// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/minimum-altitude.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/minimum-altitude/minimum-altitude-rules.js';
import g1 from '../lessons/air-law/minimum-altitude/minimum-altitude.js';

mount([g0, g1]);
